/**
 * SortIcon/index.js
 * desc: sort icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const SortIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="sort icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.sort.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 19 21" xmlns="http://www.w3.org/2000/svg"><path d="M7.25016 3.25L10.5002 0L13.7502 3.25H7.25016ZM13.7502 17.25L10.5002 20.5L7.25016 17.25H13.7502ZM6.89016 12.55H4.00016L3.28016 15.25H0.910156L4.00016 5.25H7.00016L10.1302 15.25H7.67016L6.89016 12.55ZM4.33016 10.93H6.56016L5.93016 8.81L5.67016 7.84L5.42016 6.88H5.39016L5.17016 7.85L4.93016 8.83L4.33016 10.93ZM11.0502 15.25V13.99L15.8002 7.22V7.16H11.5002V5.25H18.7302V6.59L14.0902 13.25V13.33H18.8002V15.25H11.0502Z"/></svg>
    </IconButton>
);



export default SortIcon;
